import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/font-awesome-in-element.less'
import './assets/style/base.less'
import '@/router/permission' //路由守卫
import formatTime from '@/utils/formatTime'//格式化时间
import global from '@/components/common/Global.vue'
import VueClipboard from 'vue-clipboard2'

Vue.use(ElementUI, { size: 'small' })
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$formatTime = formatTime
Vue.prototype.GLOBAL = global;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
